export enum TaskColumns {
  phase,
  task,
  due,
  button,
}
